var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEditGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86283 3.225H2.71744C2.10033 3.225 1.6001 3.72523 1.6001 4.34234V13.2811C1.6001 13.8982 2.10033 14.3984 2.71744 14.3984H11.6562C12.2733 14.3984 12.7735 13.8982 12.7735 13.2811V7.1357",
    stroke: "#37A90F",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9003 2.67886L8.5797 8.99947L6.60449 9.39453L6.99953 7.41932L13.3202 1.09869C13.5383 0.880528 13.8921 0.880528 14.1102 1.09869L14.9003 1.88879C15.1185 2.10695 15.1185 2.46067 14.9003 2.67886Z",
    stroke: "#37A90F",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5303 1.88859L14.1104 3.46875",
    stroke: "#37A90F",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditGreen);
export default __webpack_public_path__ + "static/media/ic-edit-green.9b847b5e9b147a311f1bcff12addf64d.svg";
export { ForwardRef as ReactComponent };